/*
 * api — superfície pública do client da Members API do portal (§4.3). Páginas e
 * hooks importam DAQUI, nunca dos arquivos internos: interface, HTTP e mock
 * andam sempre em sincronia porque os dois implementam `BlogApiClient`.
 */
export type { BlogApiClient, TokenProvider } from './client';
export * from './errors';
export * from './purchase-input';
export { BlogApiProvider, useBlogApi } from './api-context';
export { blogKeys } from './query-keys';
export {
  NOTIFICATIONS_REFETCH_MS,
  PURCHASE_POLL_INTERVAL_MS,
  PURCHASE_POLL_MAX_MS,
  SITE_STALE_MS,
  type CourseCatalogQuery,
  type PurchaseQuery,
  useAdminDeleteNotification,
  useAdminNotifications,
  useAdminSaveNotification,
  useAdminSaveSiteLinks,
  useAdminSaveSiteSettings,
  useAdminSaveTeam,
  useAdminSite,
  useCancelPurchase,
  useCourse,
  useCourseCatalog,
  useCourses,
  useEnrollFreeCourse,
  useLessonContent,
  useMarkNotificationsSeen,
  useMyCommunity,
  useMyEntitlements,
  useMyHistory,
  useMyNotifications,
  useMyProfile,
  useMyPurchases,
  useMyResources,
  usePurchase,
  useSite,
  useStartCoursePurchase,
  useTracks,
  useUpdateMyProfile,
} from './hooks';
export * from './types';

import type { BlogApiClient, TokenProvider } from './client';
import { HttpBlogApiClient } from './http-client';
import { MockBlogApiClient } from './mock-client';

/** O portal roda no MESMO flag de mocks da plataforma (`VITE_USE_MOCKS`). */
export const USE_MOCKS = import.meta.env.VITE_USE_MOCKS === 'true';

/**
 * Monta o client ativo. Mock ignora baseUrl. O real lê `VITE_PORTAL_API_URL` — sem
 * ela as chamadas saem relativas ao próprio host (degradação honesta: respondem
 * 404 e a UI mostra o estado de erro, nunca um dado inventado).
 */
export function createBlogApiClient(getToken: TokenProvider): BlogApiClient {
  if (USE_MOCKS) {
    return new MockBlogApiClient({ getToken });
  }
  return new HttpBlogApiClient({
    baseUrl: (import.meta.env.VITE_PORTAL_API_URL ?? '').trim(),
    getToken,
  });
}
